export const SET_ALL_INDUCTION_OPTIONS = 'SET_ALL_INDUCTION_OPTIONS';
export const SET_ALL_MEDICINE_OPTIONS = 'SET_ALL_MEDICINE_OPTIONS';
